import {
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Divider,
  Typography,
  Stack,
  IconButton,
  styled,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import { useArgusAuth } from "../../hooks/useArgusAuth";
import useArgusSearch from "../../hooks/ArgusSearchHook";
import { useArgusCart } from "../../contexts/ArgusCartContext";
import { useTheme } from "@mui/system";
import CustomButton from "../CustomButton";
import cssVariables from "../../utils/cssVariables";
import MobileSearchPage from "../MobileSearchPage/MobileSearchPage";
import MobileSiteTopbar from "./../MobileHeader/MobileSiteTopbar";
import MobileSiteBottombar from "./../MobileHeader/MobileSiteBottombar";
import TopbarShopByCategoryDrawer from "../MobileShopByCategoryDrawer/TopbarShopByCategoryDrawer";
import BottombarShopByCategoryDrawer from "../MobileShopByCategoryDrawer/BottombarShopByCategoryDrawer";

const TabletHeader = ({
  gotoLoginPage,
  gotoRegistrationPage,
  gotoCartPage,
  performLogout,
  handleAccountDropdownClick,
  cartItems,
  totalGarageItems,
  categoriesAndTypes,
  openSavedVehiclesModal,
  tecfinityAccountName,
  tecfinityAccountNumber,
  tecfinityAvailableCredit,
  firstName,
  lastName,
}) => {
  const { handleAddToCart } = useArgusCart();
  const { loading, pricingData, products, setSearchTerm } = useArgusSearch();
  const { isAuthenticated, isLoading } = useArgusAuth();
  const [searchInput, setSearchInput] = useState("");
  const [debouncedTerm, setDebouncedTerm] = useState(searchInput);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [mobileCategoriesDrawerOpen, setMobileCategoriesDrawerOpen] =
    useState(false);
  const [mobileTypesDrawerOpen, setMobileTypesDrawerOpen] = useState(false);
  const [categoryToDisplay, setCategoryToDisplay] = useState(null);
  const [drawerSource, setDrawerSource] = useState("topbar"); // Track drawer source
  const searchInputRef = useRef(null);

  const theme = useTheme();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleSearch = () => {
    setMobileSearchOpen(!mobileSearchOpen);
  };

  const toggleCategories = (source = "bottombar") => {
    setDrawerSource(source);
    setMobileCategoriesDrawerOpen(!mobileCategoriesDrawerOpen);
  };

  const toggleTypes = () => {
    setMobileTypesDrawerOpen(!mobileTypesDrawerOpen);
  };

  const handleCategoryClick = (category) => {
    setCategoryToDisplay(category);
    toggleTypes();
  };

  const handleCloseTypesClick = () => {
    setCategoryToDisplay(null);
    toggleTypes();
  };

  const StyledInputBase = styled("input")(({ theme }) => ({
    width: "100%",
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.default,
    boxShadow: theme.shadows[1],
    border: "none",
    outline: "none",
  }));

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedTerm(searchInput);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [searchInput]);

  useEffect(() => {
    if (debouncedTerm) {
      setSearchTerm(debouncedTerm);
    }
  }, [debouncedTerm]);

  useEffect(() => {
    if (mobileSearchOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [mobileSearchOpen]);

  return (
    <>
      <MobileSiteTopbar
        toggleMobileMenu={toggleMobileMenu}
        mobileMenuOpen={mobileMenuOpen}
        toggleSearch={toggleSearch}
        openSavedVehiclesModal={openSavedVehiclesModal}
        gotoCartPage={gotoCartPage}
        cartItems={cartItems}
        totalGarageItems={totalGarageItems}
        isAuthenticated={isAuthenticated}
        isLoading={isLoading}
        gotoLoginPage={gotoLoginPage}
        gotoRegistrationPage={gotoRegistrationPage}
        performLogout={performLogout}
        firstName={firstName}
        lastName={lastName}
        tecfinityAccountName={tecfinityAccountName}
        tecfinityAccountNumber={tecfinityAccountNumber}
        tecfinityAvailableCredit={tecfinityAvailableCredit}
        toggleCategories={() => toggleCategories("topbar")}
      />

      <MobileSiteBottombar
        toggleCategories={() => toggleCategories("bottombar")}
      />

      <MobileSearchPage
        open={mobileSearchOpen}
        onClose={toggleSearch}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        products={products}
        loading={loading}
        handleAddToCart={handleAddToCart}
        categoriesAndTypes={categoriesAndTypes}
      />

      {drawerSource === "topbar" ? (
        <TopbarShopByCategoryDrawer
          categoriesAndTypes={categoriesAndTypes}
          mobileCategoriesDrawerOpen={mobileCategoriesDrawerOpen}
          mobileTypesDrawerOpen={mobileTypesDrawerOpen}
          categoryToDisplay={categoryToDisplay}
          toggleCategories={toggleCategories}
          toggleTypes={toggleTypes}
          handleCategoryClick={handleCategoryClick}
          handleCloseTypesClick={handleCloseTypesClick}
        />
      ) : (
        <BottombarShopByCategoryDrawer
          categoriesAndTypes={categoriesAndTypes}
          mobileCategoriesDrawerOpen={mobileCategoriesDrawerOpen}
          mobileTypesDrawerOpen={mobileTypesDrawerOpen}
          categoryToDisplay={categoryToDisplay}
          toggleCategories={toggleCategories}
          toggleTypes={toggleTypes}
          handleCategoryClick={handleCategoryClick}
          handleCloseTypesClick={handleCloseTypesClick}
        />
      )}
    </>
  );
};

export default TabletHeader;
